// Hours in Dutch are written with a comma: 5,5 uur. Same honesty rule as
// money: what cannot be read is refused, never guessed.
export const formatUren = (n) =>
  (Math.round((Number(n) || 0) * 100) / 100).toLocaleString("nl-NL");

export function parseUren(raw) {
  const s = String(raw ?? "").trim().replace(",", ".");
  if (!s) return { value: null, error: null };
  const v = Number(s);
  if (!Number.isFinite(v)) {
    return { value: null, error: "Dit is geen aantal uren. Gebruik bijvoorbeeld 1,5." };
  }
  if (v < 0.25 || v > 24 || Math.abs(v * 4 - Math.round(v * 4)) > 1e-9) {
    return { value: null, error: "Uren gaan in stappen van 0,25 — minimaal 0,25 en maximaal 24." };
  }
  return { value: v, error: null };
}

export const UURTYPE_LABELS = { normaal: "Normale uren", half: "Half tarief" };
